import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row, Button, Table } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import ScrollLazyLoader from "../common/ScrollLazyLoader";
import Select from "react-select";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";

import PdfHeader from "../layout/common/PdfHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";

const FeeCollectionReport = (props) => {
  const [classOptions, setClassOptions] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [reportData, setReportData] = useState({
    classid: "",
    session_id: "",
  });
  const [feeData, setFeeData] = useState([]);
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    fetchClassRecords();
    fetchAllSessions();
  }, []);
  useEffect(() => {
    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        setUserInfo(user);
      }
    } catch (error) {
     
    }
  }, []);
  const fetchClassRecords = async () => {
    try {
      const result = await schoolApi.getActiveClassRecords();
      if (result.success) {
        const options = result.result.map((item) => ({
          value: item.id,
          label: item.classname,
        }));
        setClassOptions(options);
      }
    } catch (error) {
      console.error("Error fetching class records:", error);
    }
  };

  const fetchAllSessions = async () => {
    try {
      const sessions = await schoolApi.fetchSessions();
     
      if (sessions.success) {
        const options = sessions?.result?.map((sess) => ({
          value: sess.id,
          label: sess.year,
        }));
        setSessionOptions(options);


        const currentSession = sessions?.result?.find((sess) => {
          const currentDate = new Date();
          const startDate = new Date(sess.startdate);
          const endDate = new Date(sess.enddate);
          return currentDate >= startDate && currentDate <= endDate;
        });

        if (currentSession) {
          setReportData((prevState) => ({
            ...prevState,
            session_id: currentSession.id,
          }));
        }
      } else {
        setSessionOptions([]);
        setReportData({
          classid: "",
          session_id: "",
        });
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setReportData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSearch = async () => {
    try {
      if (!reportData?.session_id) {
        return toast.error("Please select required fields");
      }

      const result = await schoolApi.getAllStudentByClassidFeeData(reportData);
      if (result.success) {
        setFeeData(result.result);
      }
    } catch (error) {
      setFeeData([]);
      toast.error(error.response.data.message);
    }
  };

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const renderPdfHeader = (doc) => {
      const logoUrl = `/${userInfo?.tenantcode}-sidebar-logo.png`;
      doc.addImage(logoUrl, "PNG", 14, 10, 27, 27);
      doc.setFontSize(18);
      doc.text(userInfo?.companyname || "Company Name", 145, 20, {
        align: "center",
      });
      doc.setFontSize(10);
      const address = `${userInfo?.companystreet}, ${userInfo?.companystate}-${userInfo?.companypincode}, ${userInfo?.companycountry}`;
      const addressLines = doc.splitTextToSize(address, 180);
      doc.text(addressLines, 145, 26, { align: "center" });
      doc.setFontSize(12);
      doc.text(`Date: ${currentDate}`, 280, 20, { align: "right" });

      doc.line(14, 40, 283, 40);
      doc.text("Fee Collections Report", 125, 47);
    };

    renderPdfHeader(doc);

    const tableData = feeData.map((row, index) => [
      index + 1,
      row?.student_name,
      row?.parent_name,
      row?.classname + "" + (row.section_name ? `(${row.section_name})` : ""),
      row?.total_fee,
      row?.others,
      row?.netpayble,
      row?.total_deposited,
      row?.pending_amount_calculated,
    ]);

    tableData.push([
      "",
      "",
      "",
      "Total",
      totalFees.toFixed(2),
      otherFee.toFixed(2),
      netpaybleFee.toFixed(2),
      totalPaid.toFixed(2),
      totalPending.toFixed(2),
    ]);

    doc.autoTable({
      head: [
        [
          "Sr. No.",
          "Student Name",
          "Parent Name",
          "Class Name",
          "Total Fees",
          "Others",
          "Net Fee",
          "Total Paid",
          "Total Pending",
        ],
      ],
      body: tableData,
      didDrawCell: (data) => {
        doc.setLineDash([1, 1], 0);
      },
      styles: {
        borderTop: "2px solid #000",
        margin: "10px 0",
        border: 1,
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        fontSize: 10,
      },
      headStyles: {
        fillColor: "rgb(41,56,70)",
        textColor: [255, 255, 255],
        halign: "center",
        fontStyle: "bold",
      },
      columnStyles: {
        4: { halign: "right" },
        5: { halign: "right" },
        6: { halign: "right" },
        7: { halign: "right" },
        8: { halign: "right" },
      },
      margin: { top: 50 },
    });

    doc.save("Fee Collection Reports.pdf");
  };

  const totalFees = Array.isArray(feeData)
    ? feeData.reduce((acc, item) => acc + item?.total_fee, 0)
    : 0;
  const totalPaid = Array.isArray(feeData)
    ? feeData.reduce((acc, item) => acc + item?.total_deposited, 0)
    : 0;
  const totalPending = Array.isArray(feeData)
    ? feeData.reduce((acc, item) => acc + item?.pending_amount_calculated, 0)
    : 0;
  const otherFee = Array.isArray(feeData)
    ? feeData.reduce((acc, item) => acc + item?.others, 0)
    : 0;
  const netpaybleFee = Array.isArray(feeData)
    ? feeData.reduce((acc, item) => acc + item?.netpayble, 0)
    : 0;

 
  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };
  const labels = {
    beforeSelect: " ",
  };

  const headers = [
    {
      title: "Sr. No.",
      prop: "",
      width: "50px",
      cell: (row) => row.serialNumber,
      style: { textAlign: "left" },
    },

    {
      title: "Student Name",
      prop: "student_name",
      isFilterable: true,
    },
    {
      title: "Parents Name",
      prop: "parent_name",
      isFilterable: true,
    },

    {
      title: "Class Name",
      prop: "class_name",
      isFilterable: true,
      cell: (row) => `${row.classname} [${row.section_name}]`,
    },

    {
      title: "Total Fees",
      prop: "total_fee",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {formatNumberWithCommas(row.total_fee)}
        </div>
      ),
    },
    {
      title: "Others",
      prop: "others",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {formatNumberWithCommas(row.others)}
        </div>
      ),
    },
    {
      title: "Net Fee",
      prop: "netpayble",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {formatNumberWithCommas(row.netpayble)}
        </div>
      ),
    },
    {
      title: "Total Paid",
      prop: "total_deposited",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {formatNumberWithCommas(row.total_deposited)}
        </div>
      ),
    },
    {
      title: "Total Pending",
      prop: "pending_amount_calculated",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {formatNumberWithCommas(row.pending_amount_calculated)}
        </div>
      ),
    },
  ];

  const body = feeData
    ? feeData.map((student, index) => ({
        ...student,
        serialNumber: index + 1,
      }))
    : [];

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={3} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fee Collection Report
          </Link>
        </Col>
      </Row>
      <Row className="mt-5 m-0 px-4">
        <Card className="px-0 py-3 " style={{ marginTop: "-17px" }}>
          <Row className="m-0">
            <Col lg={12} className="px-3">
              <h5 className="fw-semibold">Filters</h5>
            </Col>
            <hr />
          </Row>
          <Row className="flex-row mt-3 mb-2 px-4">
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Class Name</Form.Label>
                <Form.Select
                  name="classid"
                  onChange={handleChange}
                  value={reportData.classid}
                >
                  <option key="default" value="">
                    All
                  </option>
                  {classOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Session</Form.Label>
                <Form.Select
                  name="session_id"
                  onChange={handleChange}
                  value={reportData.session_id}
                  required
                >
                  <option value="">-- Select Session --</option>
                  {sessionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col lg={4} className="d-flex align-items-end ">
              <div className="button-wrapper ">
                <Button onClick={handleSearch} variant="primary">
                  Search
                </Button>
                {feeData.length > 0 && (
                  <Button
                    onClick={handleDownload}
                    variant="primary"
                    className="mx-2"
                  >
                    Download
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </Row>
      {feeData.length > 0 && (
        <Row className="mt-5 m-0 px-4">
          <Card className="px-0 py-3">
            <Row className="flex-row mt-3 mb-2 px-4">
              <Col lg={12} className="p-0">
                <div id="reportContent">
                  <PdfHeader />
                  <div
                    style={{ borderTop: "2px solid #000", margin: "10px 0" }}
                  ></div>
                  <Row className="mt-4">
                    <Col lg={12} className="px-3">
                      <h5
                        style={{ textAlign: "center" }}
                        className="fw-semibold"
                      >
                        Fee Collection Report
                      </h5>
                      <Col lg={12} className="mt-1 px-1">
                        <DatatableWrapper
                          headers={headers}
                          body={body}
                          paginationOptionsProps={{
                            initialState: {
                              rowsPerPage: 50,
                              options: [50, 100, 200, 500, 1000],
                            },
                          }}
                        >
                          <ScrollLazyLoader maxRows={1000} step={50} />
                          <Row className="mb-3">
                            <Col
                              lg={3}
                              sm={4}
                              className="d-flex flex-col justify-content-end align-items-end"
                            >
                              <Filter />
                            </Col>
                            <Col
                              xs={12}
                              sm={6}
                              lg={5}
                              className="d-flex flex-col justify-content-start align-items-start"
                            >
                              <PaginationOptions labels={labels} />
                              <div className="mt-2">
                                <InfoPill
                                  left="Total Students"
                                  right={feeData?.length}
                                />
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              sm={6}
                              lg={4}
                              className="d-flex flex-col justify-content-end align-items-end"
                            ></Col>
                          </Row>
                          <Table
                            striped
                            className="transaction-report-table"
                            responsive
                            id="inventory-table-details"
                          >
                            <TableHeader />

                            {feeData?.length > 0 ? (
                              <>
                                <TableBody />

                                <tr>
                                  <td
                                    style={{ textAlign: "right" }}
                                    colSpan="4"
                                    className="text-right"
                                  >
                                    Totals
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {formatNumberWithCommas(totalFees)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {formatNumberWithCommas(otherFee)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {formatNumberWithCommas(netpaybleFee)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {formatNumberWithCommas(totalPaid)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {formatNumberWithCommas(totalPending)}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <TableBody>
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    No records found
                                  </td>
                                </tr>
                              </TableBody>
                            )}
                          </Table>
                          <Pagination />
                        </DatatableWrapper>
                      </Col>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
        </Row>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      ;
    </>
  );
};

export default FeeCollectionReport;